import { gql } from '@apollo/client';

export const LOGIN_USER = gql`
  mutation LoginUser($email: String!, $password: String!) {
    loginUser(email: $email, password: $password) {
      token
      user {
        _id
        email
        role
      }
    }
  }
`;

export const REGISTER_ATHLETE = gql`
  mutation RegisterAthlete(
    $email: String!
    $password: String!
    $firstName: String!
    $lastName: String!
    $sports: [String!]!
    $team: String
    $profilePicture: String
  ) {
    registerAthlete(
      email: $email
      password: $password
      firstName: $firstName
      lastName: $lastName
      sports: $sports
      team: $team
      profilePicture: $profilePicture
    ) {
      token
      user {
        _id
        email
        role
      }
    }
  }
`;

export const REGISTER_COACH_REQUEST = gql`
  mutation RegisterCoachPendingApproval(
    $email: String!
    $firstName: String!
    $lastName: String!
    $organization: String
    $profilePicture: String
  ) {
    registerCoachPendingApproval(
      email: $email
      firstName: $firstName
      lastName: $lastName
      organization: $organization
      profilePicture: $profilePicture
    )
  }
`;

export const REGISTER_WITH_INVITE = gql`
  mutation RegisterWithInvite($token: String!, $password: String!, $firstName: String, $lastName: String, $sports: [String]) {
    registerWithInvite(token: $token, password: $password, firstName: $firstName, lastName: $lastName, sports: $sports) {
      token
      user {
        _id
        email
        role
      }
    }
  }
`;

export const REQUEST_PASSWORD_RESET = gql`
  mutation RequestPasswordReset($email: String!) {
    requestPasswordReset(email: $email)
  }
`;

export const RESET_PASSWORD = gql`
  mutation ResetPassword($token: String!, $password: String!) {
    resetPassword(token: $token, password: $password) {
      token
      user {
        _id
        email
        role
      }
    }
  }
`;

export const APPROVE_COACH_REQUEST = gql`
  mutation ApproveCoachRequest($requestId: ID!) {
    approveCoachRequest(requestId: $requestId)
  }
`;

export const REJECT_COACH_REQUEST = gql`
  mutation RejectCoachRequest($requestId: ID!) {
    rejectCoachRequest(requestId: $requestId)
  }
`;

export const DELETE_MY_ACCOUNT = gql`
  mutation DeleteMyAccount {
    deleteMyAccount
  }
`;

export const DELETE_COACH = gql`
  mutation DeleteCoach($coachId: ID!) {
    deleteCoach(coachId: $coachId)
  }
`;

export const SEND_INVITE = gql`
  mutation SendInvite($email: String!, $role: String!) {
    sendInvite(email: $email, role: $role)
  }
`;